import { YourPlanRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings/billing/your-plan')({
  component: YourPlanRoute,
});
